// // При наведении на ссылку в списке проектов в доп.блоке показываем большую картинку
// $('.js-more-projects-list .more-projects__list-link').on('mouseenter', function(){
//     $(this).closest('.js-more-projects-list').addClass('_hover');
// });

// $('.js-more-projects-list .more-projects__list-link').on('mouseleave', function(){
//     $(this).closest('.js-more-projects-list').removeClass('_hover');
// });

App.W.on('barba:afterEnter', () => {
    App.D.on('mouseenter', ('.js-more-projects-list .more-projects__list-link'), function(){
        $(this).closest('.js-more-projects-list').addClass('_hover');
    }).on('mouseleave', ('.js-more-projects-list .more-projects__list-link'), function(){
        $(this).closest('.js-more-projects-list').removeClass('_hover');
    });
});

// Распределение ссылок в списке проектов в доп.блоке по колонкам
App.H.find('.js-more-projects-col').each(function() {
    let $projectsCol = $(this);
    let $projectsWrap = $(this).closest('.js-more-projects-list');
    let $projects = $(this).find('.more-projects__list-link');

    if ($projects.length > 13) {
        $projectsWrap.addClass('more-projects__list--2');
        $projectsCol.after('<div class="more-projects__col js-more-projects-col-2"></div>');

        if ($projects.length === 14) {
            replaceProjectsLinks(9, $projects.length, $projects);
            $projectsCol.addClass('_odd');

        } else if ($projects.length >= 15 && $projects.length <= 17) {
            replaceProjectsLinks(10, $projects.length, $projects);

        } else if ($projects.length >= 18 && $projects.length <= 19) {
            replaceProjectsLinks(11, $projects.length, $projects);
            $projectsCol.addClass('_odd');

        } else if ($projects.length >= 20 && $projects.length <= 21) {
            replaceProjectsLinks(12, $projects.length, $projects);

        } else if ($projects.length >= 22 && $projects.length <= 23) {
            replaceProjectsLinks(13, $projects.length, $projects);
            $projectsCol.addClass('_odd');
        }
    }
});

function replaceProjectsLinks(min, max, projects) {
    for (let i = min; i < max; i++) {
        $('.js-more-projects-col-2').append(projects[i]);
    }
}

//
$('.js-projects-row').each(function() {
    if (App.W.width() < 768) {
        setMoreProjects($(this));
    }
});

App.W.on('resize', function() {
    if (App.H.hasClass('page-category')) {
        App.H.addClass('_window-resized');
    }

    $('.js-projects-row').each(function() {
        let $projectsBlock = $(this);
        let $moreProjects;

        if (App.W.width() < 768) {
            setMoreProjects($(this));
        } else {
            $('.js-project-card').removeClass('_mob-hidden');
            $projectsBlock.siblings('.js-more-projects').find('.more-projects__list-link._mob-visible').remove();
            $moreProjects = $projectsBlock.siblings('.js-more-projects');

            let $moreProjectsNumber = $moreProjects.find('.js-more-projects-quantity');
            let moreProjectsQuantity = $moreProjects.find('.more-projects__list-link').length;
            $moreProjectsNumber.html('+' + moreProjectsQuantity);
        }
    });
});

function setMoreProjects(el) {
    let $projectsBlock = el;
    let $cards = $projectsBlock.find('.js-project-card:not(._mob-hidden)');
    let cardsQuantity = $cards.length;
    let $mobileCards = $projectsBlock.find('.js-project-card[data-mobile-show]');
    let mobCardsQuantity = $mobileCards.length || 0;
    let $moreProjects = $projectsBlock.siblings('.js-more-projects');
    let $moreProjectsList = $moreProjects.find('.js-more-projects-col');
    let $moreProjectsNumber = $moreProjects.find('.js-more-projects-quantity');

    // Классы для мобилки для блоков с основными карточками
    if (mobCardsQuantity == 0) {
        $projectsBlock.addClass('projects-row--mob-1');
        $projectsBlock.find('.js-project-card:first-child')
            .addClass('project-card--size-mob-big').attr('data-mobile-show', '').removeClass('_mob-hidden');
    } else if (mobCardsQuantity == 1) {
        $projectsBlock.addClass('projects-row--mob-1');
        $($mobileCards[0]).addClass('project-card--size-mob-big');
    } else if (mobCardsQuantity == 2) {
        $projectsBlock.addClass('projects-row--mob-2');
        $($mobileCards[0]).addClass('project-card--size-mob-big');
        $($mobileCards[1]).addClass('project-card--size-mob-1');
    } else if (mobCardsQuantity == 3) {
        $projectsBlock.addClass('projects-row--mob-3');
        $($mobileCards[0]).addClass('project-card--size-mob-big');
        $($mobileCards[1]).addClass('project-card--size-mob-2');
        $($mobileCards[2]).addClass('project-card--size-mob-3');
    } else if (mobCardsQuantity >= 4) {
        $projectsBlock.addClass('projects-row--mob-4');
        $($mobileCards[0]).addClass('project-card--size-mob-2');
        $($mobileCards[1]).addClass('project-card--size-mob-3');
        $($mobileCards[2]).addClass('project-card--size-mob-3');
        $($mobileCards[3]).addClass('project-card--size-mob-2');

        if (mobCardsQuantity > 4) {
            for (let i = 4; i < mobCardsQuantity; i++) {
                $($mobileCards[i]).removeAttr('data-mobile-show').addClass('_mob-hidden');
            }
        }
    }
    $mobileCards = $projectsBlock.find('.js-project-card[data-mobile-show]');
    mobCardsQuantity = $mobileCards.length;

    setMobileImages($mobileCards);

    // Перенос лишних карточек из основного блока в дополнительный
    if (cardsQuantity > mobCardsQuantity) {
        $moreProjects.addClass('_mob-visible');

        for (let i = cardsQuantity - 1; i >= 0; i--) {
            let $card = $($cards[i]);
            if (!$card.is('[data-mobile-show]')) {
                $card.addClass('_mob-hidden');
                let mobCard;

                if ($card.find('a').length > 0) {
                    mobCard = `
                        <a href="${$card.find('a').attr('href')}" class="more-projects__list-link _mob-visible">
                            <img class="more-projects__img-mob _odd" src="${$card.attr('data-mob-image-rectangle')}" alt="">
                            <img class="more-projects__img-mob _even" src="${$card.attr('data-mob-image-square')}" alt="">
                            ${$card.find('.js-project-card-title').html()}
                        </a>
                    `;
                } else {
                    mobCard = `
                        <div class="more-projects__list-link _mob-visible">
                            <img class="more-projects__img-mob _odd" src="${$card.attr('data-mob-image-rectangle')}" alt="">
                            <img class="more-projects__img-mob _even" src="${$card.attr('data-mob-image-square')}" alt="">
                            ${$card.find('.js-project-card-title').html()}
                        </div>
                    `;
                }

                $moreProjectsList.prepend(mobCard);
            }
        }
    }

    // Пересчитываем количество проектов "+N", указанное в доп.блоке
    let moreProjectsQuantity = $moreProjects.find('.more-projects__list-link').length;
    $moreProjectsNumber.html('+' + moreProjectsQuantity);

    // Считаем количество добавленных в доп.блок элементов
    let addProjectsQuantity = $moreProjects.find('.more-projects__list-link._mob-visible').length;
    if (addProjectsQuantity % 2 == 1) {
        if ($moreProjects.find('.js-more-projects-col').hasClass('_odd')) {
            $moreProjects.find('.js-more-projects-col').removeClass('_odd');
        } else {
            $moreProjects.find('.js-more-projects-col').addClass('_odd');
        }
    }
}

// определение src картинок для мобилки из атрибутов
function setMobileImages($mobileCards) {
    for (let i = 0; i < $mobileCards.length; i++) {
        let $mobileCardItem = $($mobileCards[i]);
        let $mobileCardImageWrap = $($mobileCards[i]).find('.js-project-card-img [data-lazy-bg]');
        let $mobileCardImage = $($mobileCards[i]).find('.js-project-card-img img._mobile');

        if ($mobileCardItem.hasClass('project-card--size-mob-big') ||
                $mobileCardItem.hasClass('project-card--size-mob-3')) {
            $mobileCardImage.attr('src', $mobileCardImage.closest('.js-project-card').data('mob-image-square'));
            $mobileCardImageWrap.attr('data-lazy-bg', $mobileCardImage.closest('.js-project-card').data('mob-image-square'));

        } else if ($mobileCardItem.hasClass('project-card--size-mob-1') ||
                    $mobileCardItem.hasClass('project-card--size-mob-2')) {
            $mobileCardImage.attr('src', $mobileCardImage.closest('.js-project-card').data('mob-image-rectangle'));
            $mobileCardImageWrap.attr('data-lazy-bg', $mobileCardImage.closest('.js-project-card').data('mob-image-rectangle'));
        }
    }
}


// WEBPACK FOOTER //
// ./_src/js/modules/MoreProjects.js